var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48059 0.883448C8.15835 0.483676 7.70315 0.197783 7.18812 0.0716989C6.67308 -0.0543856 6.12811 -0.0133435 5.64076 0.188232C5.20455 0.365974 4.81552 0.665646 4.5 1.06333C4.18448 0.664673 3.79545 0.365001 3.35924 0.188232C2.87189 -0.0133435 2.32692 -0.0543856 1.81188 0.0716989C1.29685 0.197783 0.841648 0.483676 0.519405 0.883448C0.179588 1.30388 0 1.82933 0 2.40281C0 3.22812 0.521259 4.13356 1.54915 5.095C2.38675 5.87811 3.37654 6.51946 3.89183 6.83197C4.07339 6.94169 4.28444 7 4.5 7C4.71556 7 4.92661 6.94169 5.10817 6.83197C5.62304 6.51946 6.61325 5.87811 7.45085 5.095C8.47874 4.13395 9 3.22812 9 2.40281C9 1.82933 8.82041 1.30388 8.48059 0.883448Z",
    fill: "url(#paint0_linear_3248_24290)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3248_24290",
    x1: 4.5,
    y1: 0,
    x2: 4.5,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D284CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C96EA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.9a734106f0aada91efd41aa0067889e8.svg";
export { ForwardRef as ReactComponent };